import GatsbyImage from 'gatsby-image'
import React from 'react'
import styled from 'styled-components'

import Container from '~/components/Container'
import Markdown from '~/components/Markdown'
import styles from '~/utils/styles'
import useI18n, { HOME_DESCRIPTION } from '~/utils/useI18N'

const MainHero = ({ descriptionMarkdown, image, title }) => {
  const defaultDescription = useI18n(HOME_DESCRIPTION)
  return (
    <HeaderContainer>
      <AsideContainer>
        {image && <Avatar {...image} />}
        <DetailsContainer>
          {title && <h1>{title}</h1>}
          {typeof descriptionMarkdown !== 'undefined' ? (
            <DescriptionMarkdown dangerouslySetInnerHTML={{ __html: descriptionMarkdown }} />
          ) : (
            <Description>{defaultDescription}</Description>
          )}
        </DetailsContainer>
      </AsideContainer>
    </HeaderContainer>
  )
}

export default MainHero

const HeaderContainer = styled.div`
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.1);
  background-color: ${({ theme: { colors } }) => colors.lightGray};

  ${({ theme: { spacing } }) => `
    margin-bottom: ${spacing.lg};
    padding-bottom: ${spacing.lg};
    padding-top: ${spacing.lg};
  `}
`

const AsideContainer = styled(Container)`
  display: flex;

  ${styles.breakpoints.md} {
    align-items: center;
  }
`

const DetailsContainer = styled.div`
  color: ${({ theme: { colors } }) => colors.orange};
  font-size: 2.5rem;
  flex: 1;

  &:not(:first-child) {
    margin-left: ${({ theme: { spacing } }) => spacing.md};
  }
`

const Avatar = styled(GatsbyImage)`
  border-radius: 50%;
  height: 80px !important;
  min-width: 80px !important;
  width: 80px !important;

  ${styles.breakpoints.md} {
    height: 150px !important;
    min-width: 150px !important;
    width: 150px !important;
  }
`

const Description = styled.p`
  color: ${({ theme: { colors } }) => colors.gray};
  font-family: 'Montserrat', sans-serif;
  font-size: 1.5rem;
  line-height: 1.2;
  max-width: none;
  ${({ theme: { spacing } }) => `margin-top: ${spacing.sm};`}

  ${styles.breakpoints.md} {
    font-size: 1.8rem;
    max-width: 80%;
  }
`

const DescriptionMarkdown = styled(Markdown)`
  color: ${({ theme: { colors } }) => colors.gray};
  font-family: 'Montserrat', sans-serif;
  font-size: 1.4rem;
  line-height: 1.2;
  max-width: none;
  ${({ theme: { spacing } }) => `margin-top: ${spacing.xs};`}

  ${styles.breakpoints.md} {
    font-size: 1.6rem;
    max-width: 80%;
  }

  a {
    ${({ theme: { colors } }) => `
      color: ${colors.gray};

      &:focus,
      &:hover {
        color: ${colors.darkPink};
      }
    `};
  }
`
